export default __webpack_public_path__ + "static/media/Path3549.c6d68d12.svg";